// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"169":"e096b5fb","337":"e25d460a","375":"2810b838","453":"0bdb65aa","478":"92149e86","638":"6d4a08de","664":"790fbab1","687":"d7865346"}[chunkId] + ".chunk.js";
};